import axios from 'axios'


/* funcition to fetch the data from the api using Axios & Async,Await
 - we pass type to return one of the types (restrunts or hotels or attractions )
 - we pass (map boundaries) to the function when calling it on other component so it can fetch places to specifc place on the map 
 - the main code of the prams & Headers is coming from the api website   */
export const getPlacesData = async (type,ne,sw)=> {
try {
    const {data : {data}} = await axios.get(`https://travel-advisor.p.rapidapi.com/${type}/list-in-boundary`, {    
        params: { bl_latitude: sw.lat, tr_latitude: ne.lat, 
               bl_longitude: sw.lng, tr_longitude: ne.lng } ,
               headers: {
                'x-rapidapi-host': 'travel-advisor.p.rapidapi.com',
                'x-rapidapi-key': process.env.REACT_APP_RAPID_API_TRAVEL_API_KEY
              }
      } ) ;
    return data ;    
} catch (error) {
    console.log(error)
} }


//fetch the weather from open weather map API 
  export const getWeatherData = async (lat,lng)=> {
    try {
        const {data} = await axios.get('https://community-open-weather-map.p.rapidapi.com/find', { 
            params: {lon: lng, lat: lat},
              headers: {
                'x-rapidapi-host': 'community-open-weather-map.p.rapidapi.com',
                'x-rapidapi-key': process.env.REACT_APP_RAPID_API_WEATHER_API_KEY
              }           
          } ) ;
        return data ;    
    } catch (error) {
        console.log(error)
    } }
  
